import { Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicFormComponent } from 'core/dynamic-form';
import { filterAllTruthyInTuple, subjectFromObs } from 'core/rx-js';
import { BehaviorSubject, Subject, combineLatest, filter, map, switchMap, take, takeUntil } from 'rxjs';
import { ActorAuthChecklistService } from '../actor-auth.checklist/actor-auth.checklist.service';
import { IActorSplugDialogData } from '../actor-splug-info/actor-splug-info.component';
import { IActorAuthDef } from './types/i-actor-auth.def';

@Injectable()
export class ActorAuthService {
  private readonly _destroy = new Subject<void>()

  readonly actorAuthDefSubject = new BehaviorSubject<IActorAuthDef>(null)

  readonly checkedSubject = new BehaviorSubject<boolean>(false)
  get checked() {
    return this.checkedSubject.value;
  }

  readonly formSubject = new BehaviorSubject<DynamicFormComponent>(undefined)
  get form() {
    return this.formSubject.value;
  }

  readonly mainGroupSubject = subjectFromObs({
    observable: this.formSubject.pipe(
      filter(Boolean),
      switchMap((form) => form.mainFormGroupSubject),
      filter(Boolean)
    ),
    initialValue: null,
    until: this._destroy
  })

  get isValid() {
    if (!this.checked || !this.form) {
      return true;
    }

    this.form.submittedSubject.next(true);

    const formGroup = this.form.mainFormGroup;
    if (!formGroup) {
      return true;
    }

    return formGroup.valid;
  }


  readonly configuredAuthObs = combineLatest([
    this.actorAuthDefSubject,
    this._actorAuthChecklistService.configuredAuthsSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      map(([actorAuthDef, configuredAuths]) => configuredAuths.find(({ name }) => name === actorAuthDef.type))
    )


  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: IActorSplugDialogData,
    private readonly _actorAuthChecklistService: ActorAuthChecklistService
  ) {

    this.configuredAuthObs.pipe(
      filter(Boolean),
      takeUntil(this._destroy)
    )
      .subscribe((configuredAuth) => {
        this.checkedSubject.next(true);
        this.mainGroupSubject.
          pipe(
            filter(Boolean),
            take(1),
          )
          .subscribe((mainGroup) => mainGroup.setValue(configuredAuth.params))
      })
  }


  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }

}
